// extracted by mini-css-extract-plugin
export default {"ImageSliceShow":"image-slice-show_ImageSliceShow__RMAhp","more":"image-slice-show_more__D637x"};